import React from 'react';
import { Tabs } from 'antd';
import { emptyFun } from '@untils/common';
import { connect } from 'dva';

const GeneralTabs = props => {
  const { className, style, onChange = emptyFun, defaultActiveKey = '', activeKey, children, authCodeList } = props;

  let clist = [];

  if (typeof children === 'object') {
    clist = [children];
  } else {
    clist = children;
  }

  return (
    <Tabs
      className={className}
      style={style}
      defaultActiveKey={defaultActiveKey}
      onChange={onChange}
      type="card"
      activeKey={activeKey}
    >
      {clist.map(item => {
        const { props = {} } = item;
        const { authCode } = props;

        if (authCodeList.indexOf(authCode) > -1 || !authCode) {
          return item;
        }
      })}
    </Tabs>
  );
};

const mapStateToProps = state => {
  return { authCodeList: state.userInfo.code_list };
};

export default connect(mapStateToProps)(GeneralTabs);
